import { styled } from '@mui/material';

export const EditorWrapper = styled('div')(({ theme }) => ({
  marginTop: 12,
  border: `1px solid ${theme.palette.novotalk.$borderColorLight}`,
  borderRadius: 10,
  overflow: 'hidden',
  background: theme.palette.novotalk.$backgroundColor,
}));

export const EditorContent = styled('div')({
  padding: 16,
});

export const TemplatesRow = styled('div')({
  display: 'flex',
  gap: 8,
  marginTop: 12,
  flexWrap: 'wrap',
});

export const AvailableTypesBox = styled('div')(({ theme }) => ({
  marginTop: 12,
  padding: 10,
  borderRadius: 8,
  border: `1px solid ${theme.palette.novotalk.$borderColorLight}`,
  background: theme.palette.novotalk.$backgroundColorVeryLightBlue,
}));

export const TypesList = styled('ul')(({ theme }) => ({
  margin: '8px 0 0',
  paddingInlineStart: 18,
  color: theme.palette.novotalk.$textColorDarkBlue,
  lineHeight: '20px',
}));

export const TemplateButton = styled('button')(({ theme }) => ({
  border: `1px solid ${theme.palette.novotalk.$borderColorLightBlue}`,
  borderRadius: 8,
  background: theme.palette.novotalk.$backgroundColor,
  color: theme.palette.novotalk.$textColorDarkBlue,
  padding: '6px 10px',
  fontSize: 12,
  cursor: 'pointer',
  '&:hover': {
    background: theme.palette.novotalk.$backgroundColorVeryLightBlue,
  },
}));

export const LinkTag = styled('a')(({ theme }) => ({
  display: 'inline-block',
  color: theme.palette.novotalk.$textColorDarkBlue,
  fontSize: 18,
  fontWeight: 600,
  direction: 'rtl',
  transition: 'color 0.2s ease, text-decoration-color 0.2s ease',
  '&:hover': {
    color: theme.palette.novotalk.$activeColor,
  },
}));

export const EditorGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 12,
  padding: '0 16px 16px',
});

export const JsonInput = styled('textarea')(({ theme, hasError }) => ({
  width: '100%',
  minHeight: 420,
  marginTop: 8,
  fontFamily: 'monospace',
  fontSize: 13,
  padding: 12,
  borderRadius: 8,
  border: `1px solid ${hasError ? theme.palette.novotalk.$warningColor : theme.palette.novotalk.$borderColorLight}`,
  outline: 'none',
  background: theme.palette.novotalk.$backgroundColor,
  color: theme.palette.novotalk.$textColorDarkBlue,
  resize: 'vertical',
  '&:focus': {
    borderColor: hasError ? theme.palette.novotalk.$warningColor : theme.palette.novotalk.$borderColorLightBlue,
    boxShadow: `0 0 0 2px ${hasError ? theme.palette.novotalk.$warningColor : theme.palette.novotalk.$borderColorLightBlue}`,
  },
}));

export const PreviewPanel = styled('div')(({ theme }) => ({
  marginTop: 8,
  minHeight: 420,
  overflow: 'auto',
  border: `1px solid ${theme.palette.novotalk.$borderColorLight}`,
  borderRadius: 8,
  padding: 12,
  background: theme.palette.novotalk.$backgroundColor,
}));

export const ErrorText = styled('div')(({ theme }) => ({
  marginTop: 8,
  color: theme.palette.novotalk.$warningColor,
}));